<template>
  <el-sub-menu v-if="menu.children?.length" :index="menu.key">
    <template #title>
      <el-icon><component :is="menu.icon" /></el-icon>
      <span>{{ menu.title }}</span>
    </template>
    <AdminSidebarMenu v-for="child in menu.children" :key="child.key" :menu="child" />
  </el-sub-menu>
  <el-menu-item v-else-if="menu.path" :index="menu.path">
    <el-icon><component :is="menu.icon" /></el-icon>
    <template #title>{{ menu.title }}</template>
  </el-menu-item>
</template>

<script setup lang="ts">
import type { AdminMenuItem } from '@/config/adminMenus'

defineOptions({ name: 'AdminSidebarMenu' })
defineProps<{ menu: AdminMenuItem }>()
</script>
